import React, { useState, useEffect, useRef } from 'react';
import MediaDisplay from './MediaDisplay';
import PlayButton from './PlayButton';

import config from './../../config';

function MediaListItem(props) {
	const getMediaType = (item) => item.path.toLowerCase().endsWith('.pdf') || item.extension == 'pdf' ? 'Pdf skrá' :
		item.path.toLowerCase().endsWith('.mov') || item.path.toLowerCase().endsWith('.mp4') ? 'Myndband' :
		item.path.toLowerCase().endsWith('.mp3') ? 'Hljóðskrá' :
		'';

	const getMediaName = (media) => media ? media.name && media.name != '' ? media.name : (media.path || '').split('/').slice(-1)[0] : ''

	const playButton = useRef(null);

	return <tr>
		<td width="30">
			{
				props.item.path.toLowerCase().endsWith('.mp3') &&
				<PlayButton ref={playButton}
					className="small"
					audioUrl={props.item.path}
					itemId={props.item.id}
					itemTitle={getMediaName(props.item)} />
			}
			{
				(props.item.path.toLowerCase().endsWith('.pdf') || props.item.extension == 'pdf') &&
				<span className="icon text mr-2" />
			}
			{
				(props.item.path.toLowerCase().endsWith('.jpg') || props.item.path.toLowerCase().endsWith('.png')) &&
				<span className="icon text mr-2" />
			}
			{
				(props.item.path.toLowerCase().endsWith('.mov') || props.item.path.toLowerCase().endsWith('.mp4')) &&
				<span className="icon video mr-2" />
			}
		</td>
		<td>
			<a onClick={(event) => {
				event.preventDefault();

				if (props.item.path.toLowerCase().endsWith('.mp3')) {
					playButton.current.play();
				}
				else {
					props.onSelect({
						name: getMediaName(props.item.name),
						url: config.mediaUrl+props.item.path,
						extension: props.item.extension
					});
				}
			}} href={config.mediaUrl+props.item.path}>{getMediaName(props.item)}</a>
		</td>
		<td>
			{props.item.text || ''}
		</td>
		<td>
			{props.item.credit || ''}
		</td>
		<td>
			{
				getMediaType(props.item)
			}
		</td>
	</tr>
}

function MediaList(props) {
	const [selectedMedia, setSelectedMedia] = useState(null);

	return (
		props.data &&
		<React.Fragment>
			{
				props.children
			}
			{
				selectedMedia &&
				<MediaDisplay className="mb-2" media={selectedMedia} onClose={() => setSelectedMedia(null)} />
			}
			<table className="table">
				<tbody>
					{
						props.data.map((item, index) => {
							return <MediaListItem key={index} item={item} onSelect={(event) => {
								setSelectedMedia(event);
							}} />
						})
					}
				</tbody>
			</table>
		</React.Fragment>
	)
}

export default MediaList;
